import { BaseUrl } from './base_url_enum'
import Api from './index'
import { ILoginApiResponse, ILoginApiSuccessResponse } from './types/login_api'
import { IUpdateUserRequest } from './types/sessions'

export const inviteUser = async (
  relationNumber: number,
  email: string
) => await Api<ILoginApiResponse<unknown>>('POST', 'user/invite', BaseUrl.Login, {
  relationNumber,
  email
})

export const verifyInvite = async (
  email: string,
  type: string,
  relationNumber: number,
  password: string,
  passwordConfirmation: string
) => await Api<ILoginApiResponse<unknown>>('POST', 'user/invite/verify', BaseUrl.Login, {
  email,
  type,
  relationNumber,
  password,
  passwordConfirmation
})

export const deleteUser = async (): Promise<ILoginApiResponse<unknown>> => await Api('DELETE', 'user', BaseUrl.Login)

export const deleteInvite = async (relationNumber: number, token: string): Promise<ILoginApiResponse<unknown>> => await Api('DELETE', `user/invite/${token}`, BaseUrl.Login, {
  relationNumber
})

export const updateUser = async (
  request: IUpdateUserRequest
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('PUT', 'user', BaseUrl.Login, request)
